import styles from "./MileageLogsStats.module.scss";
import React from "react";
import useFormat from "../../../util/useFormat";
import {useTranslation} from "react-i18next";

export const MileageLogsStats = ({mileageLogs, selectedCar}) => {
  const {formatNumber, formatAmount} = useFormat();
  const {t} = useTranslation("cars");

  if (!selectedCar) {
    return null;
  }

  return <div className={styles.toolbar}>
    <div className={styles.stat}>
      <div className={styles.statName}>{t("stat_fillups_count")}</div>
      <div className={styles.statValue}>
        {mileageLogs.length}
      </div>
    </div>
    <div className={styles.stat}>
      <div className={styles.statName}>{t("stat_best_conso")}</div>
      <div className={styles.statValue}>
        {mileageLogs.length > 1 ? formatNumber(Math.min(...mileageLogs.filter(ml => ml.conso).map(ml => ml.conso)), "#T##0D000") + " " + selectedCar.consoUnit : "-"}
      </div>
    </div>
    <div className={styles.stat}>
      <div className={styles.statName}>{t("stat_worst_conso")}</div>
      <div className={styles.statValue}>
        {mileageLogs.length > 1 ? formatNumber(Math.max(...mileageLogs.filter(ml => ml.conso).map(ml => ml.conso)), "#T##0D000") + " " + selectedCar.consoUnit : "-"}
      </div>
    </div>
    <div className={styles.stat}>
      <div className={styles.statName}>{t("stat_total_distance")}</div>
      <div className={styles.statValue}>
        {formatNumber(mileageLogs.filter(ml => ml.distance).map(ml => ml.distance).reduce((a, b) => a + b, 0), "#T##0D##") + " " + selectedCar.odometerUnit}
      </div>
    </div>
    <div className={styles.stat}>
      <div className={styles.statName}>{t("stat_bigger_distance")}</div>
      <div className={styles.statValue}>
        {mileageLogs.length > 1 ? formatNumber(Math.max(...mileageLogs.filter(ml => ml.distance).map(ml => ml.distance)), "#T##0D##") + " " + selectedCar.odometerUnit : "-"}
      </div>
    </div>
    <div className={styles.stat}>
      <div className={styles.statName}>{t("stat_total_price")}</div>
      <div className={styles.statValue}>
        {formatAmount(mileageLogs.map(ml => ml.quantity * ml.price).reduce((a, b) => a + b, 0))}
      </div>
    </div>
    <div className={styles.stat}>
      <div className={styles.statName}>{t("stat_best_price")}</div>
      <div className={styles.statValue}>
        {mileageLogs.length > 0 ? formatAmount(mileageLogs.reduce((prev, curr) => prev.price < curr.price ? prev : curr).price) : "-"}
      </div>
    </div>
    <div className={styles.stat}>
      <div className={styles.statName}>{t("stat_worst_price")}</div>
      <div className={styles.statValue}>
        {mileageLogs.length > 0 ? formatAmount(mileageLogs.reduce((prev, curr) => prev.price > curr.price ? prev : curr).price) : "-"}
      </div>
    </div>
  </div>;
};
